import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./Components/Header/Header";
import Main from "./Components/Main/Main";
import Footer from "./Components/Footer/Footer";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // Duration should match the loader animation duration

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {loading ? (
        <div id="loader">
          <div id="texify">Texify</div>
          <div id="elite">Elite</div>
        </div>
      ) : (
        <div id="content">
          <Header />
          <Main />
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
